import React, { useState } from "react";
import { Tabs, Tab, Box, useMediaQuery, Theme } from "@mui/material";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import CategoriesList from "@/pages/settings/component/CategoriesList";
import ProfilePage from "../profile";
import CompanyPage from "../company";
import ComingSoonPage from "./component/ComingSoonPage";
// import useOffer from "@/hooks/useTender";
// import { CategoryOption } from "@/app/features/tender/tenders-mine-page";

function SettingsPage() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [activeTab, setActiveTab] = useState(0);
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const isTablet = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const tabLabels = [
    t("navigation.MyProfile"),
    t("checkout.fields.company"),
    t("navigation.Settings"),
    t("status.payment"),
    t("status.shipping"),
    t("general.permissions"),
    t("company.fields.categories"),
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <ProfilePage />;
      case 1:
        return <CompanyPage />;
      case 2:
        return <ComingSoonPage />;
      case 3:
        return <ComingSoonPage />;
      case 4:
        return <ComingSoonPage />;
      case 5:
        return <ComingSoonPage />;
      case 6:
        return <CategoriesList />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col py-2">
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        textColor={"inherit"}
        centered={false}
        variant={isMobile ? "scrollable" : isTablet ? "scrollable" : "standard"}
        scrollButtons={isMobile ? "auto" : isTablet ? "auto" : undefined}
        sx={{
          "& .MuiTabs-scroller": {
            overflow: "scroll !important",
            scrollbarWidth: "none",
            marginLeft: 4,
            marginRight: 2,
          },
          "& .MuiTabs-flexContainer": {
            justifyContent: "flex-start",
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "#000",
          },
          // "& .MuiTab-root": {
          //   fontSize: isMobile ? "0.8rem" : "1rem",
          //   minWidth: isMobile ? "auto" : 120,
          //   padding: isMobile ? "6px 12px" : "12px 16px",
          // },
        }}
      >
        {tabLabels.map((label, index) => (
          <Tab
            key={index}
            label={label}
            sx={{
              fontWeight: "normal",
              fontSize: 18,
              color: "#000", // Active tab color and default color
              backgroundColor:
                activeTab === index ? "transparent" : "transparent", // Highlight active tab
              borderRadius: "0px", // Add some styling
              boxShadow: activeTab === index ? "unset" : "unset",
              borderBottom:
                activeTab === index ? "3px solid #000" : "3px solid #fff",
              marginRight: 2, // Add spacing between tabs
              paddingX: 2, // Add padding for the tabs
              transition: "all 0.3s ease", // Smooth transition for hover or active styles
            }}
          />
        ))}
      </Tabs>
      <Box sx={{ padding: 2 }}>{renderTabContent()}</Box>
      {/* </section>
        </main>
      </div> */}
    </div>
  );
}

export default SettingsPage;
